"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntermediateRecordConfigSchema = exports.artifactType = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().min(2).max(100),
    loanProductSlug: zod_1.z.string().min(2).max(100).optional(),
    creditFacilitySlug: zod_1.z.string().min(2).max(100).optional(),
    externalFilename: zod_1.z.string().optional(),
    configuration: zod_1.z.object({}).optional(),
});
exports.nodeType = 'db_node';
exports.artifactType = 'db_node';
exports.IntermediateRecordConfigSchema = zod_1.z.object({});
//# sourceMappingURL=types.js.map